var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLoginMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_login_mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-1",
    transform: "translate(-797.000000, -926.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_login_mail",
    transform: "translate(794.000000, 921.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Depth",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(3.000000, 5.000000)",
    fill: "#A3AFB7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2 L2,12 L16,12 L16,2 L2,2 Z M16,0 C17.1,0 18,0.9 18,2 L18,12 C18,13.1 17.1,14 16,14 L2,14 C0.9,14 0,13.1 0,12 L0,2 C0,0.9 0.9,0 2,0 L16,0 Z",
    id: "Fill-1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4971862,1.5 L8.16907638,7.17192885 C8.60652353,7.60935705 9.31456685,7.60935705 9.752014,7.17192885 L15.4241862,1.5 L17.796806,1.50033179 C17.6481497,1.94046662 17.3984798,2.35395534 17.0477963,2.70464391 L11.1664049,8.58612026 C9.94791613,9.80462658 7.97255045,9.80462658 6.75614105,8.58612026 L0.873709963,2.70464391 C0.522825701,2.35405397 0.272984447,1.94069922 0.124186199,1.50070318 L2.4971862,1.5 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginMail);
export default __webpack_public_path__ + "static/media/icon_login_mail.19121dc286b24e00d977731d801a0372.svg";
export { ForwardRef as ReactComponent };